module.exports = __webpack_public_path__ + "static/media/idrive.302c581e.svg";